import React from "react";
import Grid from "@mui/material/Grid2";

import { Form, AgreementsAutocomplete, ProductsAutocomplete } from "@shared/components";
import { useDateOptions, useMediaTypeOptions } from "@shared/options";

export const ReceivedBookListFilters = React.memo(() => {
  const { getMediaTypeOptions } = useMediaTypeOptions();
  const { getMonthOptions, getYearOptions } = useDateOptions();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <AgreementsAutocomplete name="agreement_id" label="Convênio" />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <ProductsAutocomplete name="product_id" label="Produto" />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input name="document" label="CPF / Documento" />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Select name="month" label="Mês" options={getMonthOptions()} />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Select name="year" label="Ano" options={getYearOptions()} />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Select name="book_type" label="Tipo" options={getMediaTypeOptions()} />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input name="isbn" label="ISBN" />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input name="issn" label="ISSN" />
      </Grid>
    </Grid>
  );
});
